import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Flex, lighten, rem, FlexProps } from '@mantine/core';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import type { RippleColor } from './RippleIcon.types';

interface Props {
	variant: PredefinedIcons;
	color?: RippleColor;
}

export const RippleIcon = ({ variant, color }: Props) => {
	return (
		<StyledRippleIconContainer align="center" justify="center" $currentColor={color}>
			<Icon variant={variant} size="vlg" />
		</StyledRippleIconContainer>
	);
};

const StyledRippleIconContainer = styled(Flex)<
	FlexProps & {
		$currentColor?: RippleColor;
	}
>`
	padding: ${rem('6px')};
	border-radius: 50%;

	${({ $currentColor, theme }) => {
		let borderColor = theme.v3.colors.gray[0];
		let bgColor = theme.v3.colors.gray[2];
		let iconColor = theme.v3.colors.dark[8];

		switch ($currentColor) {
			case 'red': {
				borderColor = '#fff4f5';
				bgColor = theme.v3.colors.red[0];
				iconColor = theme.v3.colors.red[6];
				break;
			}
			case 'blue': {
				borderColor = theme.v3.colors.blue[0];
				bgColor = lighten(theme.v3.colors.blue[6], 0.75);
				iconColor = theme.v3.colors.blue[6];
				break;
			}
			case 'orange': {
				borderColor = theme.v3.colors.orange[0];
				bgColor = lighten(theme.v3.colors.orange[6], 0.75);
				iconColor = theme.v3.colors.orange[6];
				break;
			}
		}

		return `
          border: 6px solid ${borderColor};
          background-color: ${bgColor};
          color: ${iconColor};
       `;
	}}
`;
